import * as React from 'react'

import { copy } from '@local/do-secundo-clipboard-utilities'
import { LoyaltyDisplayIcon } from '@toasttab/buffet-pui-icons'

import { useGetPromoBanners } from '../useGetPromoBanners/useGetPromoBanners'

export interface PromoBannerProps {
  testId?: string | number
}

export const PromoBanner = ({ testId = 'promo-banner' }: PromoBannerProps) => {
  const [isCopied, setIsCopied] = React.useState(false)

  // query for active banners for a restaurant
  const { data: { promoBanners } = {}, error, loading } = useGetPromoBanners()

  if (loading || error || !promoBanners?.banners?.length) {
    return null
  }

  // for now only displaying the first banner
  const [banner] = promoBanners.banners

  if (!banner?.bannerText || !banner?.promoCode) {
    return null
  }

  const { bannerText, promoCode } = banner

  // copies the promo code to clipboard
  const handleCopyClick = async (promoCodeText: string) => {
    try {
      await copy(promoCodeText)
      setIsCopied(true)
    } finally {
      setTimeout(() => setIsCopied(false), 1500)
    }
  }

  return (
    <div
      className='rounded bg-neutral-0 mb-6 xl:mb-9 ml-6 xl:ml-2 mr-6 xl:mr-3 px-2.5 pt-2.5 pb-4 xl:p-2 flex flex-row xl:items-center justify-center text-default'
      data-testid={testId}
    >
      <LoyaltyDisplayIcon size='md' />
      <div className='flex flex-row flex-wrap flex-1 xl:flex-none ml-2 xl:ml-5'>
        <span className='font-semibold mb-3 xl:mb-0'>{bannerText}</span>
        <div className='w-full xl:w-auto'>
          <span className='xl:ml-6'>{promoCode}</span>
          <button
            className='text-color-link text-base font-semibold border-none active:bg-transparent focus:bg-transparent bg-transparent cursor-pointer ml-4 p-0 w-24'
            data-testid={`${testId}-copy-button`}
            id='promoBannerCopyButton'
            onClick={() => handleCopyClick(promoCode)}
          >
            {isCopied ? 'Copied!' : 'Copy code'}
          </button>
        </div>
      </div>
    </div>
  )
}
